import { SxProps, Theme } from "@mui/material";

export const dialogStyles: SxProps<Theme> = {
  "& .MuiDialog-paper": {
    maxWidth: "730px",
    width: "100%",
    paddingX: "20px",
    paddingY: "25px",
  },
};

export const typographyStyles: SxProps<Theme> = {
  fontFamily: "Montserrat",
  fontWeight: 600,
  fontSize: 18,
};

export const labelTypography: SxProps<Theme> = {
  fontFamily: "Roboto",
  paddingBottom: "8px",
  fontWeight: 500,
};

export const deleteButtonStyles: SxProps<Theme> = {
  width: "250px",
  fontWeight: 600,
  "&.Mui-disabled": {
    color: "#bfbdbd",
    backgroundColor: "#e8e3e3",
    border: "1px solid #e8e3e3",
  },
};

export const buttonContainerStyles: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  mt: "35px",
  gap: "30px",
};

export const saveButtonStyles: SxProps<Theme> = {
  backgroundColor: "#333",
  width: "250px",
  fontWeight: 600,
};
